import React, { useState, useEffect } from "react";
import wishlistFallback from "../Assets/Course app-pana (1) 7.png";
import cross from "../Assets/cross.png";
import {
  getWishlistByUser,
  removeFromWishlist,
  moveToCart
} from "../Common/apis";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import Aos from "aos";

const WishlistSubComponent = () => {
  useEffect(() => {
      Aos.init({
        duration: 1000, // animation duration in ms
        once: true,     // animate only once
      });
    }, []);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("GISUL_TOKEN");

  useEffect(() => {
    fetchWishlist();
  }, []);

  const fetchWishlist = async () => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      const response = await getWishlistByUser();
      setWishlist(response?.data?.courses || []);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (courseId) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await removeFromWishlist({ courseId });
      fetchWishlist();
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMoveToCart = async (courseId) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await moveToCart({ courseId });
      fetchWishlist();
      toast.success("Moved to cart successfully!");
    } catch (error) {
      console.error("Error moving to cart:", error);
      toast.error("Failed to move to cart");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:gap-[30px] gap-[20px]">
      {loading ? <Loader /> : null}
      <div className="profile-info-heading overflow-hidden">
        <h3 data-aos="fade-right">Wishlist</h3>
        <p data-aos="fade-left">({wishlist.length || 0} items)</p>
      </div>
      <div className="wishlist-cards">
        {wishlist.length === 0 ? (
          <p>Your wishlist is empty.</p>
        ) : (
          wishlist.map((item) => (
            <div className="wishlist-card pb-[25px]" key={item._id}>
              <img
                src={
                  (item?.images?.length > 0 && item.images[0]) ||
                  wishlistFallback
                }
                alt={item.name}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "10px"
                }}
              />
              <h3>{item.name}</h3>
              {/* <div className="wish-btn">
                <button className="white-btn">{item.duration || "N/A"}</button>
                <button
                  className="yellow-btn"
                  onClick={() => handleMoveToCart(item._id)}
                >
                  Move to Cart
                </button>
              </div>
              <div className="remover-btn-div" style={{ marginTop: "10px" }}>
                <img
                  src={cross}
                  alt="Remove"
                  onClick={() => handleRemove(item._id)}
                  style={{
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                  }}
                  className="remove-btn"
                />
              </div> */}
              <div className="wish-btn">
                <button
                  className="yellow-btn"
                  onClick={() => handleMoveToCart(item._id)}
                >
                  Move to Cart
                </button>
                <button
                  className="white-btn"
                  onClick={() => handleRemove(item._id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default WishlistSubComponent;
